import { render } from "./nav-item.vue?vue&type=template&id=b58406ce&scoped=true"
import script from "./nav-item.vue?vue&type=script&lang=js"
export * from "./nav-item.vue?vue&type=script&lang=js"

import "./nav-item.vue?vue&type=style&index=0&id=b58406ce&lang=less&scoped=true"

import exportComponent from "/home/runner/work/easticloud-admin/easticloud-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b58406ce"]])

export default __exports__